import React,{ Component } from 'react';
import {connect}           from 'react-redux';
import { Link }            from 'react-router-dom';
import {iframe }           from '../../actions/jogosAction';
import {GetTipoAtividade}  from '../../actions/atividadesAction'; 
import {Config}            from '../../actions/configActions';

class Desafios_Jogos extends Component{

    constructor(props){
        super(props);
        this.state = {
                        ati_id   : this.props.match.params.ati_id,
                        ati_tipo : this.props.match.params.ati_tipo,
                        titulo   : ""
                    }
    }

    componentWillMount(){
        localStorage.setItem('ati_id',this.state.ati_id);
    }

    renderJogos(){
        const obj = {}	
        switch (this.state.ati_tipo) {

            case this.props.menu.desafios.jogo.tipo1: 
                  obj.retorno = this.props.iframe(`${Config().ip}/animacoes/chave/chave.html`);
            break;
          
            case this.props.menu.desafios.jogo.tipo2: 
                 obj.retorno = this.props.iframe(`${Config().ip}/animacoes/forca/forca.html`);
            break;

            case this.props.menu.desafios.jogo.tipo3: 
                 obj.retorno = this.props.iframe(`${Config().ip}/animacoes/quiz/quiz.html`);
            break;

            default:
            break;
        }

        return obj.retorno; 
    }

    render(){
       
        return(
                <div className="container-bg">
                     <div className="titulo-pages topo_conteudo">
                        <span>{this.props.GetTipoAtividade(this.state.ati_tipo)}</span>
                    </div>

                    <div className="panel panel-azul-claro panel-cinza">
                         <div className="panel-heading clearfix">
                             <div className="pull-right">
                                <Link to= {this.props.config.desafios.home} className = "btn btn-default btn-xs ">Voltar</Link>
                             </div>
                          </div>
                          <div className="panel-body">
                                <div dangerouslySetInnerHTML={{__html: this.renderJogos()}}/>
                                   <div className="alert alert-info">
                                    <b>Atenção: </b>Sua pontuação só será atualizada se você ganhar mais XP ou pontos do que na sua última tentativa. Ou seja, só será considerada a maior pontuação obtida.	
                                </div> 
                          </div>
                    </div>  
                   
                </div>
             );
}

}

function mapStateToProps(state){
    
        return {
          config : state.configReducer.menu
        }
    }

export default connect(mapStateToProps,{iframe,GetTipoAtividade})(Desafios_Jogos);


// WEBPACK FOOTER //
// ./src/components/jogos/desafios_jogos.js